<template>
  <ImageGallery v-model:current-image="currentImage" :images="images" />
</template>

<script setup lang="ts">
import { computed, type ComputedRef, ref, type Ref, watch } from 'vue';
import { useCollectionStore } from '@/stores/Collection/CollectionStore.ts';
import ImageGallery from '@/pages/ProductPage/partials/ProductDetailPage/ImageGallery.vue';
import _ from 'lodash';
import type { ConfigurableCollectionProductImageObject } from '@/types/joostconnector';

const store = useCollectionStore();

const images: ComputedRef<ConfigurableCollectionProductImageObject[]> =
  computed(
    () =>
      _.filter([
        store.selectedEndProductValue?.defaultImage,
        ...Object.values(store.selectedEndProductValue?.images ?? {}),
      ]) as ConfigurableCollectionProductImageObject[]
  );
const currentImage: Ref = ref(images.value[0] ?? undefined);
watch(
  () => store.selectedEndProductValue,
  () => {
    currentImage.value = images.value[0];
  }
);
</script>
